import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {InformationModalComponent} from './information-modal.component';

@Injectable({
    providedIn: 'root'
})
export class InformationModalService extends ModalService {
    testModal() {
        this.createModalComponent(InformationModalComponent);
        this.showModalComponent();
    }
}
